import { cn } from '@/lib/utils'

/** Same label show/hide motion as `NavLink` sidebar (`iconOnly` ↔ expanded). */
export function sidebarRailFooterLabelClass(compact: boolean) {
  return cn(
    'flex min-w-0 flex-col justify-center overflow-hidden transition-[max-width,opacity,transform] duration-200 ease-out motion-reduce:transition-none',
    compact
      ? 'pointer-events-none max-w-0 translate-y-1 opacity-0'
      : 'max-w-[min(256px,calc(100%-1.5rem))] translate-y-0 opacity-100'
  )
}

/** Flat rail row trigger: same shell as inactive `NavLink` sidebar (left-anchored icon + label). */
export function sidebarRailFooterTriggerClass({ pressed }: { pressed?: boolean }) {
  return cn(
    // Explicit h-10 + py-0 (not min-h + py) so consumers can override height with h-9/h-11/h-12 and it always wins.
    'group relative flex h-10 w-full shrink-0 cursor-inherit items-center justify-start gap-2 rounded-lg border-0 bg-transparent px-2 py-0 text-[14px] font-normal transition-[padding,gap,background-color,color] duration-200 ease-out motion-reduce:transition-none',
    'text-atrium-black hover:bg-atrium-content active:bg-atrium-content active:text-accent-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-2 focus-visible:ring-offset-atrium-sidebar',
    // pressed && 'bg-atrium-content'
  )
}
